import { useManufacturers } from '../../useManufacturers';
import styles from './ManufacturersHeader.module.css';
import { useManufacturersHeader } from './useManufacturersHeader';
import { Button, Input, InputPicker } from 'rsuite';
import { country_list, status_types } from '../../../Settings/Data/lists';
import { getAccessLevel } from '../../../../helperFunctions';
function ManufacturersHeader() {
	let { showCreateManufacturer } = useManufacturers();

	let { filter, searchValues, statusHandler, countryHandler, searchInputHandler } = useManufacturersHeader();

	let countryOptions = [
		{ label: 'All countries', value: '*' },
		...country_list.map((item) => ({ label: item, value: item })),
	];

	let statusOptions = [
		{ label: 'All statuses', value: '*' },
		...status_types.map((item) => ({ label: item, value: item.toLowerCase() })),
	];

	let buttonAddManufacturer = <div />;
	let accessLevel = getAccessLevel();
	if (accessLevel >= 2) {
		buttonAddManufacturer = (
			<div className={styles.button_container}>
				<Button onClick={showCreateManufacturer} color='blue' appearance='primary' style={{ width: '200px' }}>
					Add New Manufacturer
				</Button>
			</div>
		);
	}

	//! Render
	return (
		<>
			<div className={styles.manufacturers_header}>
				<div className={styles.manufacturers_header_title}>Manufacturers</div>
				<div className={styles.manufacturers_header_options}>
					<Input
						id='name'
						value={searchValues?.name}
						onChange={searchInputHandler}
						placeholder='Search by name'
						style={{ height: 36, width: 224, fontSize: 'var(--font-size)' }}
					/>

					<InputPicker
						value={filter?.country}
						onChange={countryHandler}
						cleanable={false}
						placeholder='Select Country'
						data={countryOptions}
						style={{ width: 224 }}
					/>

					{buttonAddManufacturer}
				</div>
			</div>
		</>
	);
}

export default ManufacturersHeader;
